'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var Info = function (_React$Component) {
	_inherits(Info, _React$Component);

	function Info() {
		_classCallCheck(this, Info);

		return _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).apply(this, arguments));
	}

	_createClass(Info, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    doc = _props.doc,
			    actions = _props.actions;

			var subheading = this.props.subheading || doc.info.version;

			return _react2.default.createElement(
				'div',
				{ className: 'info' },
				_react2.default.createElement(
					'div',
					{ className: 'title-and-action' },
					_react2.default.createElement(
						'div',
						{ className: 'title-and-version' },
						_react2.default.createElement(
							'h3',
							{ className: 'title' },
							doc.info.title
						),
						subheading && _react2.default.createElement(
							'h5',
							{ className: 'version ux-item-spacing-m-left' },
							subheading
						)
					),
					actions && _react2.default.createElement(
						'div',
						{ className: 'actions ux-item-spacing-m-left' },
						actions
					)
				),
				_react2.default.createElement(
					'p',
					{ className: 'description' },
					doc.info.description
				)
			);
		}
	}]);

	return Info;
}(_react2.default.Component);

Info.propTypes = {
	/**
  * Valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired,

	/**
  * Override `version` to display a sub-heading instead
  */
	subheading: _propTypes2.default.string,

	/**
  * An array of actions to render with the info.
  */
	actions: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

var _default = Info;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Info, 'Info', 'src/components/SwaggerUI/Info.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/Info.jsx');
}();

;